import { createGetService } from '@ligo/shared/utils';
import { RESOURCES } from '../resources';
import { Label } from '../models/partners';

export const LabelService = createGetService<Label>(RESOURCES.LABELS);
